export const SideBarWidth = 240;